import React from "react";
import classNames from "classnames";

import DatePickerInput from "components/datePickerInput/DatePickerInput";
import DateBar from "elements/teesheet/DateBar";
import TeesheetDatePickerNav from "elements/teesheet/TeesheetDatePickerNav";
import TeesheetDateWeather from "elements/teesheet/TeesheetDateWeather";
import { MOBILE_WIDTH } from "helpers/ScreenSizes";
import { TWeather } from "redux/reducers/models/facility";

interface ITeesheetDateControlsRowProps {
  selectedDate: Date;
  onDateChange: (date: Date) => void;
  weather: TWeather | null;
  windowWidth: number;
  bookingDragActive?: boolean;
}

export default function TeesheetDateControlsRow(props: ITeesheetDateControlsRowProps) {
  const mobileCompact = props.windowWidth <= MOBILE_WIDTH;
  const desktopDateBarDays = props.windowWidth > 1080 ? 8 : 0;
  const mediumTabletDateBarDays =
    props.windowWidth > MOBILE_WIDTH && props.windowWidth <= 1080 && props.windowWidth >= 1000 ? 7 : 0;
  const smallTabletDateBarDays = props.windowWidth > MOBILE_WIDTH && props.windowWidth < 1000 ? 5 : 0;
  const dateBarDays = desktopDateBarDays || mediumTabletDateBarDays || smallTabletDateBarDays;

  const datePicker = (
    <DatePickerInput
      months={1}
      position={props.windowWidth <= MOBILE_WIDTH ? "center" : "left"}
      centeredInputText={props.windowWidth <= MOBILE_WIDTH}
      startingDate={props.selectedDate}
      setStartingDate={props.onDateChange}
      iconOnlyTrigger={!mobileCompact}
    />
  );

  return (
    <div className="facility-new-teesheet-controls mt-3 mb-3">
      <div className="teesheet-date-selection-header">
        {mobileCompact ? (
          <TeesheetDatePickerNav selectedDate={props.selectedDate} onDateChange={props.onDateChange}>
            {datePicker}
          </TeesheetDatePickerNav>
        ) : (
          <>
            <div
              className={classNames("teesheet-date-selection-header-input", {
                "teesheet-date-selection-header-input-icon-only": !mobileCompact,
              })}
            >
              {datePicker}
            </div>
            {dateBarDays > 0 && (
              <DateBar
                numberOfDays={dateBarDays}
                onClick={props.onDateChange}
                selectedDate={props.selectedDate}
                showNavigation
                bookingDragActive={props.bookingDragActive}
              />
            )}
          </>
        )}
      </div>
      <div className="teesheet-date-weather">
        <TeesheetDateWeather weather={props.weather} />
      </div>
    </div>
  );
}
